import { render } from "./simpleEditor.vue?vue&type=template&id=43080890"
import script from "./simpleEditor.vue?vue&type=script&lang=js"
export * from "./simpleEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__